<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
  >
    <v-card>
      <SheetHeader :title="title" @sheetClose="$emit('sheetClose')"/>
      <v-card-text>
        <div ref="capture">
          <v-img
              width="100%"
              aspect-ratio="1.65"
              class="rounded"
              :src="photo"
          >
            <div class="text-area" v-html="str"></div>
          </v-img>
        </div>
        <!-- <div class="pos-relative d-flex justify-center my-7">
            <v-img
              min-height="178"
              width="100%"
              class="rounded"
              :src="getImage('ic_sleep_06.png')"
              >
            </v-img>
            <div class="text-area" v-html="str"></div>
        </div> -->
      </v-card-text>
      <v-card-actions>
        <v-btn x-large block depressed
               color="primary"
               @click="divSave"
        >{{ btnStr }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import SheetHeader from "./SheetHeader";
import html2canvas from "html2canvas"

export default {
  props: {
    sheet: Boolean,
    photo: String,
    str: String,
    title: String,
    btnStr: String
  },
  data: () => ({
    file: null,
    files: [],
  }),
  components: {
    SheetHeader,

  },
  mounted() {
    window.kakaoImgUrl = this.kakaoImgUrl;
  },
  methods: {
    divSave() {
      if (this.btnStr === "공유하기") {

        html2canvas(this.$refs.capture, {allowTaint: true, useCORS: true, backgroundColor: "transparent", scale: 4}
        ).then(canvas => {

          this.fileCreate(canvas.toDataURL('image/png', 1.0))
        });

      } else {
        html2canvas(this.$refs.capture, {allowTaint: true, useCORS: true, backgroundColor: "transparent", scale: 4}
        ).then(canvas => {
          this.down(canvas.toDataURL('image/jpeg', 1.0), 'img.jpeg')
        });
      }
    },
    down(uri, fileName) {
      var link = document.createElement('a')
      link.href = uri
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    fileCreate(uri) {
      var blobBin = atob(uri.split(',')[1]);	// base64 데이터 디코딩
      var array = [];

      for (var i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
      }
      var blob = new Blob([new Uint8Array(array)], {type: 'image/png'});	// Blob 생성

      const myFile = new File([blob], 'image.jpeg', {
        type: blob.type,
      });
      // console.log("myFile : ", myFile)
      this.file = myFile
      // console.log("this.file : ", this.file)

      this.files.splice(0, this.files.length)
      this.files.push(this.file)
      // console.log('11'+this.files)

      this.upload()

    },
    kakaoImgUrl(url) {
      // console.log('url : ',url)
      this.$emit('kakaoShare', url)
    },
    async upload() {

      window.Kakao.Share.uploadImage({
        file: this.files,
      })
        .then(function (response) {
          console.log(response.infos.original.url);
          window.kakaoImgUrl(response.infos.original.url)
        })
        .catch(function (error) {
          console.log(error);
        })
    },
  }
}
</script>
<style lang="scss" scoped>
.text-area {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.66) !important;
  border-radius: 2px;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  min-height: unset !important;
  padding: 16px;
  font-size: 18px;
  color: #000;
  overflow-y: auto;
}
</style>
